export default __webpack_public_path__ + "static/media/Blog12.10.b4dd7aeb.png";